import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ClassReportType, HighlightedProps } from '../../types';
import { SectionLayout, getFilteredAverage, getOthersAverage } from '../modules';
import { StudentProgress } from '../../../components';

type Props = {
  classReport: ClassReportType;
  showOthersData: boolean;
  hideAverage?: boolean;
  chartIsExpanded?: boolean;
} & HighlightedProps;

const MathsAge = ({
  classReport,
  showOthersData,
  highlightedLabel,
  highlightedIds,
  hideAverage,
  chartIsExpanded,
  onElementClick,
}: Props): JSX.Element => {
  const { translate } = useI18n();

  const value = classReport.mathsAgeAverage.toFixed(2);
  const highlightedAverage = highlightedLabel
    ? getFilteredAverage(classReport.students.all, highlightedIds, (student) => student.chartsData.mathsAge > 0 ? student.chartsData.mathsAge : null)
    : null;
  const othersAverage = showOthersData
    ? getOthersAverage(classReport.students.all, highlightedIds, (student) => student.chartsData.mathsAge > 0 ? student.chartsData.mathsAge : null)
    : null;

  return (
    <SectionLayout
      title={translate('pages.REPORTS.SECTIONS.MATHS_AGE.title')}
      value={value}
      highlightLabel={highlightedLabel}
      highlightValue={highlightedAverage?.toFixed(2) ?? null}
      othersLabel={showOthersData && highlightedIds.length > 0 ? translate('pages.REPORTS.HEADERS.OTHERS') : null}
      othersValue={othersAverage?.toFixed(2) ?? null}
      unit={translate('pages.REPORTS.SECTIONS.MATHS_AGE.unit', { count: parseFloat(value) })}
      moreInfo={translate('pages.REPORTS.SECTIONS.MATHS_AGE.info')}
      disableChartToggle={classReport.students.all.length <= 0}
      className={'pdf-no-break'}
      data-cy="maths-age"
      hideAverage={hideAverage}
      chartIsExpanded={chartIsExpanded}
      id='maths-age-container'
    >
      <StudentProgress
        thinAxis
        showOthersData={showOthersData}
        data={classReport.students.all ?? []}
        chartType={'mathsAge'}
        highlightedIds={highlightedIds}
        removeUnassessed={true}
        onElementClick={onElementClick}
      />
    </SectionLayout>
  );
};

export default MathsAge;
